import React from 'react';
import PropTypes from 'prop-types';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosButtonsContainer from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import { NEW } from 'shared/constants/SharedConstants';

const ProfileActionsSection = ({ profile, profileActions, onResetData, mode, mappingInfo, history }) => {
  const handleSaveProfile = () => {
    if (mode === NEW) {
      profileActions.addProfile(profile, mappingInfo, history);
    }
    else {
      profileActions.updateProfile(profile, mappingInfo, history);
    }
    profileActions.resetProfileEditionMode();
  };

  const handleResetData = () => {
    profileActions.resetProfile();
    onResetData();
  };

  return (
    <SovosButtonsContainer align="right" style={ { paddingRight: 15, margin: '15px 0 30px 0' } }>
      <SovosRaisedButton style={ { width: 90 } } onClick={ handleResetData } color="secondary" >RESET</SovosRaisedButton>
      <SovosRaisedButton style={ { width: 90 } } disabled={ profile.name === '' || profile.transformedFileType === '' || profile.maps.length === 0 } onClick={ handleSaveProfile } >SAVE</SovosRaisedButton>
    </SovosButtonsContainer>
  );
};

ProfileActionsSection.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  profile: PropTypes.object.isRequired,
  mappingInfo: PropTypes.array.isRequired,
  onResetData: PropTypes.func,
  mode: PropTypes.string,
  profileActions: PropTypes.shape({
    addProfile: PropTypes.func,
    resetProfile: PropTypes.func,
    updateProfile: PropTypes.func
  }).isRequired
};

ProfileActionsSection.defaultProps = {
  onResetData: () => null,
  mode: NEW
};

export default ProfileActionsSection;



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/profileActionsSection/ProfileActionsSection.js